import fetchRequest from '../utils/fetchRequest';

const rtkFetchRequest = () => {
  return async (args, api, extraOptions) => {
    try {
      const { endpoint, method, body } = args;
      let response = {};
      switch (method) {
        case 'GET':
          response = await fetchRequest.get(endpoint, body);
          break;
        case 'POST':
          response = await fetchRequest.post(endpoint, body);
          break;
        case 'PATCH':
          response = await fetchRequest.patch(endpoint, body);
          break;
        default:
          throw new Error('Request method not provided');
      }
      const data = response?.data;
      return { data };
    } catch (error) {
      return { error };
    }
  };
};

export default rtkFetchRequest;
